import { sendMessage } from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function setFetching(moduleId: string) {
    return function(fetching: boolean = true) {
        sendMessage('setFetching', Maybe.just(JSON.stringify({ moduleId, fetching })));
    };
}
